<template>
	<div class="mdocksFormHeader puiformheader"></div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'mdocks-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mdocks'
		};
	},
	computed: {}
};
</script>
